/* Stapelkorting / bundelkiezer — Rebelz Archive (dependency-vrij) */
(function () {
  'use strict';

  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  function parseJSON(s, fb) { try { return JSON.parse(s); } catch (e) { return fb; } }

  /* ============================================================
     PRODUCTPAGINA
     ============================================================ */
  function initBundle() {
    var box = document.querySelector('[data-bundle]');
    var form = document.querySelector('[data-product-form]');
    if (!box || !form) return;

    var tiers = parseJSON(box.dataset.tiers, []);
    var options = parseJSON(box.dataset.options, []);
    var productEl = document.getElementById('ProductJson-' + form.dataset.productId);
    var product = productEl ? parseJSON(productEl.textContent, null) : null;
    if (!product || !tiers.length) return;

    var radios = box.querySelectorAll('[data-bundle-tier]');
    var tierEls = box.querySelectorAll('.bundle-tier');
    var rowsWrap = box.querySelector('[data-bundle-rows]');
    var idInput = form.querySelector('input[name="id"]');
    var buyBtn = form.querySelector('[data-add-to-cart]');
    var buyText = form.querySelector('[data-add-to-cart-text]');
    var hasOptions = !!form.querySelector('[data-option-index]');

    function currentTier() {
      var c = box.querySelector('[data-bundle-tier]:checked');
      return c ? parseInt(c.value, 10) || 1 : 1;
    }
    function tierPct(q) {
      var p = 0;
      tiers.forEach(function (t) { if (q >= t.q && t.p > p) p = t.p; });
      return p;
    }
    function currentVariant() {
      var id = parseInt(idInput.value, 10);
      return product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
    }
    function variantFor(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      }) || null;
    }
    function mainSelection() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        if (c) opts[parseInt(g.dataset.optionIndex, 10)] = c.value;
      });
      return opts;
    }

    /* Prijzen per staffel op basis van de huidige variant */
    function renderPrices() {
      var v = currentVariant();
      var price = v ? v.price : parseInt(box.dataset.price, 10) || 0;
      tierEls.forEach(function (el, i) {
        var t = tiers[i]; if (!t) return;
        /* Zelfde afronding als Shopify: korting per regel afgerond, daarna × aantal */
        var each = price - Math.round(price * t.p / 100);
        var total = each * t.q;
        var eachEl = el.querySelector('[data-bundle-each]');
        var totalEl = el.querySelector('[data-bundle-total]');
        var wasEl = el.querySelector('[data-bundle-was]');
        if (eachEl) eachEl.textContent = t.q > 1 ? money(each) + ' per stuk' : '';
        if (totalEl) totalEl.textContent = money(total);
        if (wasEl) {
          if (t.p > 0) { wasEl.textContent = money(price * t.q); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
      });
    }

    /* Extra keuzerijen (item 2..n) */
    function buildRows() {
      var q = currentTier();
      rowsWrap.innerHTML = '';
      if (q <= 1 || !hasOptions) { rowsWrap.hidden = true; return; }
      var base = mainSelection();
      var hint = document.createElement('p');
      hint.className = 'bundle__rows-hint';
      hint.textContent = 'Kies per item de kleur en maat:';
      rowsWrap.appendChild(hint);
      for (var n = 1; n <= q; n++) {
        var row = document.createElement('div');
        row.className = 'bundle-row' + (n === 1 ? ' bundle-row--main' : '');
        row.setAttribute('data-bundle-row', n);
        var name = document.createElement('span');
        name.className = 'bundle-row__name';
        name.textContent = 'Item ' + n;
        var sels = document.createElement('div');
        sels.className = 'bundle-row__selects';
        options.forEach(function (opt, oi) {
          if (opt.sw && opt.v.length > 1) {
            /* Kleur: swatches (zelfde stijl als de hoofdkiezer) */
            var group = document.createElement('div');
            group.className = 'bundle-swatches';
            group.setAttribute('data-bundle-opt', oi);
            group.setAttribute('role', 'radiogroup');
            group.setAttribute('aria-label', opt.n + ' item ' + n);
            var cur = document.createElement('span');
            cur.className = 'bundle-swatches__value';
            cur.setAttribute('data-bundle-swatch-value', '');
            var list = document.createElement('span');
            list.className = 'bundle-swatches__list';
            var styles = opt.s || {};
            opt.v.forEach(function (val, vi) {
              var id = 'bundle-r' + n + '-o' + oi + '-' + vi;
              var inp = document.createElement('input');
              inp.type = 'radio'; inp.id = id; inp.value = val;
              inp.name = 'bundle_r' + n + '_o' + oi;
              inp.setAttribute('form', 'bundle-no-form');
              if (base[oi] === val || (base[oi] == null && vi === 0)) inp.checked = true;
              var lab = document.createElement('label');
              lab.setAttribute('for', id);
              lab.className = 'bundle-swatch';
              lab.title = val;
              if (styles[val]) lab.setAttribute('style', styles[val]);
              var sr = document.createElement('span');
              sr.className = 'visually-hidden'; sr.textContent = val;
              lab.appendChild(sr);
              list.appendChild(inp); list.appendChild(lab);
            });
            cur.textContent = opt.n + ': ' + (base[oi] || opt.v[0]);
            group.appendChild(cur); group.appendChild(list);
            sels.appendChild(group);
          } else {
            var sel = document.createElement('select');
            sel.className = 'bundle-row__select';
            sel.setAttribute('aria-label', opt.n + ' item ' + n);
            sel.setAttribute('data-bundle-opt', oi);
            opt.v.forEach(function (val) {
              var o = document.createElement('option');
              o.value = val; o.textContent = opt.n + ': ' + val;
              if (base[oi] === val) o.selected = true;
              sel.appendChild(o);
            });
            sels.appendChild(sel);
          }
        });
        var warn = document.createElement('p');
        warn.className = 'bundle-row__warn';
        warn.hidden = true;
        warn.textContent = 'Deze combinatie is niet leverbaar.';
        row.appendChild(name); row.appendChild(sels); row.appendChild(warn);
        rowsWrap.appendChild(row);
      }
      rowsWrap.hidden = false;
      validateRows();
    }

    /* Waarde van een keuze-element: <select> of swatch-groep */
    function optValue(el) {
      if (el.tagName === 'SELECT') return el.value;
      var c = el.querySelector('input:checked');
      return c ? c.value : null;
    }

    function rowVariant(row) {
      var opts = [];
      row.querySelectorAll('[data-bundle-opt]').forEach(function (s) { opts[parseInt(s.dataset.bundleOpt, 10)] = optValue(s); });
      return variantFor(opts);
    }

    function validateRows() {
      var ok = true;
      rowsWrap.querySelectorAll('[data-bundle-row]').forEach(function (row) {
        var v = rowVariant(row);
        var bad = !v || !v.available;
        row.classList.toggle('is-unavailable', bad);
        var w = row.querySelector('.bundle-row__warn');
        if (w) w.hidden = !bad;
        if (bad) ok = false;
      });
      box.dataset.rowsValid = ok ? '1' : '0';
      syncButton();
      return ok;
    }

    function syncButton() {
      if (!buyBtn) return;
      var q = currentTier();
      var main = currentVariant();
      var mainOk = main && main.available;
      var rowsOk = box.dataset.rowsValid !== '0';
      buyBtn.disabled = !(mainOk && (q <= 1 || rowsOk));
      if (buyText) {
        if (!mainOk) { buyText.textContent = buyText.dataset.soldout; return; }
        var pct = tierPct(q);
        buyText.textContent = q > 1
          ? (buyText.dataset.add + ' · ' + q + ' stuks' + (pct ? ' (−' + pct + '%)' : ''))
          : buyText.dataset.add;
      }
    }

    /* Verzamelen + toevoegen: één call met alle items */
    function addBundle() {
      var q = currentTier();
      var main = currentVariant();
      if (!main || !main.available) return Promise.reject(new Error('unavailable'));
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (f) {
        if (f.type === 'file') return;
        if (f.name && f.value) props[f.name.replace(/^properties\[|\]$/g, '')] = f.value;
      });
      var counts = {};
      var bad = false;
      if (hasOptions) {
        rowsWrap.querySelectorAll('[data-bundle-row]').forEach(function (row) {
          var v = rowVariant(row);
          if (!v || !v.available) { bad = true; return; }
          counts[v.id] = (counts[v.id] || 0) + 1;
        });
      } else {
        counts[main.id] = q;
      }
      if (bad) return Promise.reject(new Error('unavailable'));
      var items = Object.keys(counts).map(function (id) {
        var it = { id: parseInt(id, 10), quantity: counts[id] };
        if (Object.keys(props).length) it.properties = props;
        return it;
      });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
    }

    /* Submit onderscheppen vóór theme.js (capture-fase) als er meer dan 1 item gekozen is */
    form.addEventListener('submit', function (e) {
      if (currentTier() <= 1 || !window.fetch) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      if (!validateRows()) return;
      if (buyBtn) buyBtn.disabled = true;
      addBundle().then(function (res) {
        if (buyBtn) buyBtn.disabled = false;
        if (!res.ok) { alert(res.data.description || res.data.message || 'Er ging iets mis. Probeer het opnieuw.'); return; }
        if (window.BentiorDrawer) window.BentiorDrawer.open();
      }).catch(function () {
        if (buyBtn) buyBtn.disabled = false;
        validateRows();
      });
    }, true);

    radios.forEach(function (r) { r.addEventListener('change', function () { buildRows(); syncButton(); }); });
    /* Item 1 in de kiezer = de hoofdkeuze: wijziging doorgeven aan de kleur/maat-kiezer erboven */
    function pushMainFromRow(oi, val) {
      var grp = form.querySelector('[data-option-index="' + oi + '"]');
      if (!grp) return;
      var inp = grp.querySelector('input[value="' + val.replace(/"/g, '\\"') + '"]');
      if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    /* ...en andersom: hoofdkeuze gewijzigd → rij 1 bijwerken */
    function pullRowFromMain() {
      var row = rowsWrap.querySelector('[data-bundle-row="1"]');
      if (!row) return;
      var base = mainSelection();
      row.querySelectorAll('[data-bundle-opt]').forEach(function (el) {
        var oi = parseInt(el.dataset.bundleOpt, 10);
        var val = base[oi]; if (val == null) return;
        if (el.tagName === 'SELECT') { el.value = val; return; }
        var inp = el.querySelector('input[value="' + val.replace(/"/g, '\\"') + '"]');
        if (inp) inp.checked = true;
        var lab = el.querySelector('[data-bundle-swatch-value]');
        if (lab && options[oi]) lab.textContent = options[oi].n + ': ' + val;
      });
    }
    var syncing = false;
    rowsWrap.addEventListener('change', function (e) {
      var t = e.target;
      var el = t.matches('[data-bundle-opt]') ? t : t.closest('[data-bundle-opt]');
      if (!el) return;
      if (t.type === 'radio') {
        var lab = el.querySelector('[data-bundle-swatch-value]');
        var oi0 = parseInt(el.dataset.bundleOpt, 10);
        if (lab && options[oi0]) lab.textContent = options[oi0].n + ': ' + t.value;
      }
      var row = el.closest('[data-bundle-row]');
      if (row && row.dataset.bundleRow === '1' && !syncing) {
        syncing = true;
        pushMainFromRow(parseInt(el.dataset.bundleOpt, 10), optValue(el));
        syncing = false;
      }
      validateRows();
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) {
        /* theme.js zet eerst de variant-id; daarna prijzen, rij 1 en knop bijwerken */
        setTimeout(function () { if (!syncing) pullRowFromMain(); renderPrices(); validateRows(); syncButton(); }, 0);
      }
    });

    renderPrices();
    buildRows();
    setTimeout(syncButton, 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundle();
  });
})();
